var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{on:{"click":_vm.logout}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v("Logout")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }